// 通用数据
export default {
	title: '首页' 
}